import React from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import Typography from "@material-ui/core/Typography";
import { Grid, StepButton } from "@material-ui/core";
import { prob2Percentage } from "../../api/utils/strings";
import "../../styles/devices/mob_SignStepper.css";
import { useDataProvider } from "../../api/DataProvider";
import { pDialogTab } from "../../utils/parameters";
import { useTranslation } from "react-i18next";

export default function DialogSignsStepper(props) {
  const { dialogElements, handleClickStep, activeStep, setActiveStep, sendFeedback2Server } = props;
  const { t } = useTranslation("global")

  const { json_data_lemma, json_data_glosses } = useDataProvider();

  return (
    <div className="sig_SignModal_StepperRoot">
      <Stepper className="sig_SignMatches_Root" nonLinear activeStep={activeStep} alternativeLabel>
        {dialogElements["elements"].map((lemma_id, i) => {
          return (
            <Step className="sig_SignMatches_MainContainer" key={i}>
              <StepButton
                className="sig_SignMatches_Button"
                onClick={() => {
                  handleClickStep(lemma_id, dialogElements["inference_glosses"][i]);
                  setActiveStep(i);
                }}
              >
                <Grid className="sig_SignMatches_InfoContainer" container direction="column">
                  <Grid className="sig_SignMatches_InfoName" item>
                    {json_data_lemma[lemma_id]["label"]} <br></br> {json_data_glosses[dialogElements["inference_glosses"][i]]["label"]}
                  </Grid>
                  <Grid className="sig_SignMatches_InfoPercentage" item>
                    <Typography variant="caption">{prob2Percentage(dialogElements["prob"][i])} %</Typography>
                  </Grid>
                </Grid>
              </StepButton>
            </Step>
          );
        })}
        {sendFeedback2Server !== undefined ? (
          <Step className="sig_SignMatches_MainContainer sig_SignMatches_Button_None" key={pDialogTab.none}>
            <StepButton
              icon={"?"}
              className="sig_SignMatches_Button sig_SignMatches_Button_None"
              onClick={() => {
                handleClickStep(pDialogTab.none);
                setActiveStep(activeStep);
              }}
            >
              <Grid className="sig_SignMatches_InfoContainer" container direction="column">
                <Grid className="sig_SignMatches_InfoName" item>
                  {t("sDialog.labelStepNone")}
                </Grid>
              </Grid>
            </StepButton>
          </Step>
        ) : (
          <></>
        )}
      </Stepper>
    </div>
  );
}
